import { ColumnDef } from '@tanstack/react-table';

import { RunSchema } from '@/types/schema';

import { RUNS_TABLE_COLUMNS } from './constants';

export function sortColumns<T extends RunSchema>(
  columns: ColumnDef<T, unknown>[],
  prioritizedColumns: string[] = []
): ColumnDef<T, unknown>[] {
  const excludedColumns = [
    RUNS_TABLE_COLUMNS.SELECT,
    RUNS_TABLE_COLUMNS.STATUS,
    RUNS_TABLE_COLUMNS.NAME,
  ] as const;

  // Get fixed position columns
  const fixedColumns = excludedColumns
    .map((id) => columns.find((col) => col.id === id))
    .filter((col): col is ColumnDef<T, unknown> => !!col);

  // Get remaining columns excluding fixed ones
  const remainingColumns = columns.filter(
    (col) =>
      !excludedColumns.includes(col.id as (typeof excludedColumns)[number])
  );

  // Build prioritized list in the explicit order provided
  const remainingById = new Map<string, ColumnDef<T, unknown>>(
    remainingColumns.map((c) => [c.id?.toString() ?? '', c])
  );
  const prioritizedOrdered: ColumnDef<T, unknown>[] = [];
  for (const id of prioritizedColumns) {
    const col = remainingById.get(id);
    if (col) prioritizedOrdered.push(col);
  }

  // Other columns keep their original order excluding prioritized
  const otherCols = remainingColumns.filter(
    (col) => !prioritizedColumns.includes(col.id ?? '')
  );

  return [...fixedColumns, ...prioritizedOrdered, ...otherCols];
}
